export default "__VITE_ASSET__Cpw$quOZ__"